import { ContentType } from '@/@types/common'
import { fetchOriginalPost } from '@/utils/fetchers/post'
import { POST_TYPE_TO_ROUTE_MAPPING } from '@/utils/route'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

/**
 * for legacy jike web originalPost route
 */
export const Route = createFileRoute('/(legacy)/originalPost/$id')({
	loader: async ({ params }) => {
		const post = await fetchOriginalPost(params.id)
		if (!post || !post.user?.username) {
			throw notFound()
		}
		throw redirect({
			to: '/u/$username/$type/$id',
			params: {
				username: post.user.username,
				type: POST_TYPE_TO_ROUTE_MAPPING[ContentType.POST],
				id: post.id,
			},
			replace: true,
		})
	},
})
